import React from "react"
import ContentLoader from "react-content-loader"

function ProgramItemLoader(props) {

  return (
  <ContentLoader
    speed={2}
    width={476}
    height={150}
    viewBox="0 0 474 148"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="13" y="54" rx="3" ry="3" width="54" height="30" />
    <rect x="235" y="35" rx="3" ry="3" width="176" height="10" />
    <circle cx="440" cy="65" r="30" />
    <rect x="77" y="15" rx="3" ry="3" width="146" height="108" />
  </ContentLoader>
)}

export default ProgramItemLoader;
